import logo from './logo.svg';
import './App.css';
import Navheader from './Components/Navheader';
import { Link } from 'react-router-dom';
import Background from './Components/Background';
import Element from './Components/Element';
import styles from './Components/styles.module.scss';
import Button from './Components/Button';
import Card from './Components/Card';
import Footer from './Components/Footer';
import Vid from './Components/Vid';
function App(props) {




  const gameArray = props.games;
  const gameCardsArray = props.gameCards;
   const horrorGameArray = props.horrorGames;

  let elementArray = [];

  for(let i = 0; i < 3; i++){
    elementArray.push(<Element halloween={props.halloween} xmas={props.xmas} key={i} height={"33P"} background={i}></Element>);
  }

console.log(elementArray);
  return (

    <div className="App"
    style={{
      width: '100%',
      background:'black',
      overflowX: "hidden"
    }}>
    <Background halloween={props.halloween} xmas={props.xmas} ></Background>
    <Element halloween={props.halloween} xmas={props.xmas} height={"10P"} background={2}></Element>
    <Element halloween={props.halloween} xmas={props.xmas} height={"90P"} background={4} flexColumn={true}>
   
        <div className={`${styles[`h1`]}`}>Welcome to <s>Website</s> World of</div>
        <div className={`${styles[`nevry-logo`]} ${styles[`width--33P`]} ${styles[`height--50P`]}`}></div>
        <div className={`${styles[`image`]} ${styles[`image--alignLeftBottom`]}`}
        style={{
          background: `url("/pictures/graphics/poof1.png") center/cover no-repeat`
        }}
        ></div>
        <div className={`${styles[`image`]} ${styles[`image--alignRightBottom`]}`}
           style={{
          background: `url("/pictures/graphics/fboy1.png") center/cover no-repeat`
        }}></div>
        
          <Link to={"/games"}>
       <Button halloween={props.halloween} xmas={props.xmas} size={"large"}>PLAY NOW</Button>
       </Link>
       
   
    </Element>
    <Element halloween={props.halloween} xmas={props.xmas} height={"90P"} background={5} flexColumn={true}>
   
        <div className={`${styles[`h1`]}`}>PLAY ALL AVAILABLE GAMES</div>
        <div style={{
          width:"55%",
          height:"50%",
     
          display:"flex",
          alignItems: "center",
          justifyContent: "space-around"
       
        }}> 
        {gameCardsArray.map((val)=>{return <Link style={{width: "27%", height:"100%"}} to={val.link}><Card  halloween={props.halloween} xmas={props.xmas} key={val.id} height={"100%"} width={"100%"} background={1} image={val.img} title={val.title} desc={val.description}></Card></Link>})}
 
        </div>
           <div style={{
          width:"70%",
          height:"20%",
   
       
        }}></div>
        <div className={`${styles[`image`]} ${styles[`image--alignLeftBottom`]}`}
        style={{
          background: `url("/pictures/graphics/uther.png") center/cover no-repeat`
        }}
        ></div>
        <div className={`${styles[`image`]} ${styles[`image--alignRightBottom`]}`}
           style={{
          background: `url("/pictures/graphics/cronic.png") center/cover no-repeat`
        }}></div>

       
   
    </Element>

        <Element halloween={props.halloween} xmas={props.xmas} height={"90P"} background={6} flexColumn={true}>
   
        <div className={`${styles[`h1`]}`}>Uncover Mysteries</div>

        <Vid halloween={props.halloween} xmas={props.xmas} url={'https://youtu.be/LNL5btx1BvI?si=ekeN36AltUjCSKlo'}/>

        
           <div className={`${styles[`h2`]}`}>Hidden from the eye</div>
       <div style={{
        height:"20%"
       }}></div>

         <div className={`${styles[`image`]} ${styles[`image--alignLeftBottom`]}`}
        style={{
          background: `url("/pictures/graphics/sonia1.png") center/cover no-repeat`
        }}
        ></div>
        <div className={`${styles[`image`]} ${styles[`image--alignRightBottom`]}`}
           style={{
          background: `url("/pictures/graphics/capcake1.png") center/cover no-repeat`
        }}></div>
       
    </Element>
 <Footer halloween={props.halloween} xmas={props.xmas} ></Footer>
    <Navheader halloween={props.halloween} xmas={props.xmas}  games={gameArray} horrorGames={horrorGameArray}></Navheader>
   
    </div>

    
  );
}

export default App;
